import { render, staticRenderFns } from "./AmisPreviewer.vue?vue&type=template&id=767eb7e8&scoped=true"
import script from "./AmisPreviewer.vue?vue&type=script&lang=js"
export * from "./AmisPreviewer.vue?vue&type=script&lang=js"
import style0 from "./AmisPreviewer.vue?vue&type=style&index=0&id=767eb7e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767eb7e8",
  null
  
)

export default component.exports